import { FC, useEffect, useState } from "react";

import { App, Button, Form, Input, Modal, Spin } from "antd";

import { api } from "../../../services/api";
import { IServiceType } from "../../../types";

interface ServiceTypeModalProps {
  onClose: () => void;
  onRefreshPage?: () => void;
  isModalOpen: boolean;
  serviceType?: IServiceType;
}

const ServiceTypeModal: FC<ServiceTypeModalProps> = ({
  onClose,
  onRefreshPage,
  isModalOpen,
  serviceType,
}) => {
  const { message } = App.useApp();

  const [form] = Form.useForm<IServiceType>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (serviceType) {
      form.setFieldsValue(serviceType);
    }
  }, [form, serviceType]);

  const handleCloseModal = () => {
    if (loading) {
      return;
    }
    form.resetFields();
    onClose();
  };

  const onSubmit = async () => {
    setLoading(true);
    const values = await form
      .validateFields()
      .then((values) => {
        return {
          ...values,
          name: values.name.toUpperCase(),
        };
      })
      .catch((info) => {
        info.errorFields.forEach((error: any) =>
          error.errors.forEach((msg: string) => message.error(msg))
        );
        setLoading(false);
      });

    if (!values) {
      return;
    }

    handleSubmitForm(values)
      .then((data) => {
        message.success(
          `Tipo de Serviço ${
            data.config.method === "put" ? "atualizado" : "criado"
          } com sucesso!`
        );
        handleCloseModal();
      })
      .catch((error) => {
        if (error.response.data.errors) {
          error.response.data.errors.forEach((err: any) =>
            message.error(err.message)
          );
        } else {
          message.error("Algo inesperado ocorreu!");
        }
      })
      .finally(() => {
        setLoading(false);
        if (onRefreshPage) {
          onRefreshPage();
        }
      });
  };

  const handleSubmitForm = async (values: IServiceType) => {
    if (serviceType) {
      return await api.put<IServiceType>(
        `/service-types/${serviceType.id}`,
        values
      );
    }
    return await api.post<IServiceType>(`/service-types/`, values);
  };

  return (
    <Modal
      title={`${serviceType ? "Editar" : "Cadastrar"} grupo de serviço`}
      open={isModalOpen}
      onCancel={handleCloseModal}
      footer={[
        <Button key="back" onClick={handleCloseModal} danger disabled={loading}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={onSubmit}
          loading={loading}
        >
          {serviceType ? "Salvar" : "Adicionar"}
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" name="unit_form_modal">
          <Form.Item
            label="Nome:"
            name="name"
            rules={[
              {
                required: true,
                message: "Por favor insira o nome do grupo de serviço!",
              },
            ]}
          >
            <Input placeholder="Insira o nome" />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export { ServiceTypeModal };
